import React from 'react'
import { Link } from '@LTIDashboard/modules/common'
import { StatusBadges } from '@LTIDashboard/modules/SubmissionsDashboard/Header'

export function SubHeader({ status, assignmentPK }) {
  let params = window.location.pathname.split('/')
  const courseNumber = params[3]
  return (
    <div className="d-flex justify-content-between align-items-center">
      <StatusBadges status={status} />
      <Link
        target={`/instructor/activity_submissions/${courseNumber}/${assignmentPK}`}
        text="Go to Submissions"
      />
    </div>
  )
}
